import { render } from "./SidebarMenu.vue?vue&type=template&id=0d5513df&scoped=true"
import script from "./SidebarMenu.js?vue&type=script&lang=js"
export * from "./SidebarMenu.js?vue&type=script&lang=js"

import "./SidebarMenu.scss?vue&type=style&index=0&id=0d5513df&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d5513df"]])

export default __exports__